import React, {useMemo} from 'react';
import {Section, CtaButton} from '@sail/helm';
import {useLinkResolver} from 'mkt-ssr/lib/routing/LinkResolver';
import {
  TestimonialCarousel,
  TestimonialCarouselProps,
} from 'mkt-ssr/components/sail/TestimonialCarousel/TestimonialCarousel';
import {CustomerLogoName} from 'mkt-ssr/components/sail/CustomerLogo/CustomerLogoImports';
import {TestimonialCardFields} from '@stripe-internal/mkt-ssr-models';

export type TestimonialData = TestimonialCardFields;

export interface TestimonialSectionProps {
  testimonials: Array<TestimonialData>;
}

export const TestimonialSection: React.FC<
  React.PropsWithChildren<TestimonialSectionProps>
> = ({testimonials}) => {
  const {createRoute} = useLinkResolver();

  const testimonialData = useMemo<TestimonialCarouselProps['data']>(
    () =>
      testimonials.map((testimonial) => ({
        quote: testimonial.quote,
        authorName: testimonial.authorName,
        authorRole: testimonial.authorRole,
        backgroundColor:
          testimonial.backgroundColor ||
          testimonial.customer?.brandColor ||
          '#000000',
        logo: `CustomerLogo${testimonial.customer?.logoAssetIdentifier}` as CustomerLogoName,
        cta: testimonial.cta?.url ? (
          <CtaButton href={createRoute(testimonial.cta.url)}>
            {testimonial.cta.label}
          </CtaButton>
        ) : undefined,
        orientation: 'horizontal',
        backgroundImage: testimonial.backgroundImage?.file?.url,
      })),
    [testimonials, createRoute],
  );

  return (
    <Section theme="light">
      <TestimonialCarousel data={testimonialData} />
    </Section>
  );
};
